import { CurrentPlanPaymentFailed, Grid2 } from '@aibees/shared/components';
import { useSubscriptionExpiryInfo } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { TeamMemberFilterProvider } from '@aibees/shared/views/user-management-view/context/team-member-filter-context';
import { memo } from 'react';
import { useCurrentSubscriptionApi } from '../price-and-plan/api/use-current-subscription-api';
import { CreditTeamMember } from './features/credit-team-member';
import { CurrentPlanBenefits } from './features/current-plan-benefits';
import { CurrentPlanCard } from './features/current-plan-card';
import { TotalCreditBalance } from './features/team-credit-usage/components/total-credit-balance';
import * as Styled from './styles';
import * as SX from './sx';
import type { CurrentPlanProps as Props } from './types';

export const CurrentPlan = memo(({ className }: Props) => {
  const { data, isLoading } = useCurrentSubscriptionApi();
  const expireInfo = useSubscriptionExpiryInfo();

  const current = data?.current;

  return (
    <Styled.Wrapper
      className={classnames('CurrentPlan', className)}
      sx={SX.root}
    >
      <TeamMemberFilterProvider>
        <CurrentPlanPaymentFailed />
        <Grid2
          container
          columns={48}
          spacing={2}
          justifyContent="center"
          mb={0.5}
        >
          <Grid2 xs={48} sm={48} md={48} lg={10} xl={10}>
            {current && (
              <CurrentPlanCard
                currentPlan={current}
                logoUrl="/assets/images/ark-logo-2.svg"
                expireInfo={expireInfo}
              />
            )}
          </Grid2>
          <Grid2 xs={48} sm={48} md={48} lg={38} xl={38}>
            <CurrentPlanBenefits
              currentPlan={current}
              subscriptionType="Credit"
            />
          </Grid2>
        </Grid2>
        <TotalCreditBalance />
        <CreditTeamMember />
      </TeamMemberFilterProvider>
    </Styled.Wrapper>
  );
});

CurrentPlan.displayName = 'CurrentPlan';
